import { gsap } from "gsap";

const items = document.querySelectorAll('[data-accordion="item"]')
let flag = false
// const div = document.querySelector('.js-accordion-body');
// let isActive = false;

items.forEach(item => {
  console.log(item)
  const accordionButton = item.querySelector('[data-accordion="btn"]')
  const accordionContent = item.querySelector('[data-accordion="content"]')

  accordionButton.addEventListener('click', (e) => {
    if (flag) {
      flag = false;
      item.classList.remove('is-active')
      slideUp(accordionContent, 0.5);
    } else {
      flag = true;
      item.classList.add('is-active')
      slideDown(accordionContent, 0.5);
    }
  })
})


// document.querySelector('.js-accordion-btn').addEventListener('click', () => {
//   if (isActive) {
//     isActive = false;
//     slideUp(div, 0.5);
//   } else {
//     isActive = true;
//     slideDown(div, 0.5);
//   }
// })

const PADDING_TOP_ATTRIBUTE = 'data-padding-top';
const PADDING_BOTTOM_ATTRIBUTE = 'data-padding-bottom';

/**
 * Replicates jQuery's slideDown - Display the element with a sliding motion.
 * Assumes the element is hidden with display: none;
 * 
 * @params { DOMElement }
 * @params { Number } in seconds, so 0.3 is 300ms
 */
const slideDown = (element, duration = 0.3) => {
  console.log(element)
    
  element.style.display = 'block';
  element.style.height = 'auto';

  const paddingTop = getPaddingTop(element);
  element.style.paddingTop = 0;

  const paddingBottom = getPaddingBottom(element);
  element.style.paddingBottom = 0;

  const offsetHeight = element.offsetHeight;
  const targetHeight = offsetHeight + paddingBottom + paddingTop
  element.style.height = 0;

  gsap.to(element, { 
    height: targetHeight, 
    paddingTop: paddingTop, 
    paddingBottom: paddingBottom,
    overwrite: 'auto', 
    duration: duration,
    ease: 'power1.out'
  } );

}

/**
 * アニメーションが完了する前にslideUpが切り替えられた場合に備えて、要素の参照用に上部パディングを設定します
 * 
 * @params { DOMElement }
 * 
 * @returns { Number } 
 */
const getPaddingTop = (element) => {
  if (element.getAttribute(PADDING_TOP_ATTRIBUTE)) {
    return parseFloat(element.getAttribute(PADDING_TOP_ATTRIBUTE));
  } else {
    return parseFloat(setAndGetAttribute(element, PADDING_TOP_ATTRIBUTE, parseFloat(getComputedStyle(element).paddingTop)));
  }
}

/**
 * アニメーションが完了する前にslideUpが切り替えられた場合に備えて、要素の参照用にパディングボトムを設定します
 * 
 * @params { DOMElement }
 * 
 * @returns { Number } 
 */
const getPaddingBottom = (element) => {
  if (element.getAttribute(PADDING_BOTTOM_ATTRIBUTE)) {
    return parseFloat(element.getAttribute(PADDING_BOTTOM_ATTRIBUTE));
  } else {
    return parseFloat(setAndGetAttribute(element, PADDING_BOTTOM_ATTRIBUTE, parseFloat(getComputedStyle(element).paddingBottom)));
  }
}

/**
 * Set and get an attribute on an element
 * 要素の属性を設定および取得する
 * 
 * @param { DOMElement }  
 * @param { String }
 * @param { String }
 * 
 * @returns { String }  
 */
const setAndGetAttribute = (element, attribute, value) => {
  element.setAttribute(attribute, value)
  return element.getAttribute(attribute);
}

/**
 * Replicates jQuery's slideUp - Hide the element with a sliding motion.
 * 
 * @params { DOMElement }
 * @params { Number } in seconds, so 0.3 is 300ms
 */
const slideUp = (element, duration = 0.3) => {
  console.log(element)
  const paddingTop = getPaddingTop(element);  
  const paddingBottom = getPaddingBottom(element);
  gsap.to(element, {  
      height: 0, 
      paddingTop: 0, 
      paddingBottom: 0, 
      overwrite: 'auto', 
      duration: duration, 
      ease: 'power1.in',
      onComplete: () => onSlideUpComplete(element, paddingTop, paddingBottom)
    } );
}

/**
 * Revert to it's original state
 * 元の状態に戻します
 * 
 * @params { DOMElement }
 * @params { Number }
 * @params { Number }
 */
const onSlideUpComplete = (element, paddingTop, paddingBottom) => {
  element.style.display = 'none';
  element.style.height = 'auto';
  element.style.paddingTop = `${paddingTop / 10}rem`;
  element.style.paddingBottom = `${paddingBottom / 10}rem`;
  element.removeAttribute(PADDING_TOP_ATTRIBUTE);
  element.removeAttribute(PADDING_BOTTOM_ATTRIBUTE);
}
